import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import classnames from 'classnames';
import _ from 'lodash';
import { SortableContainer, SortableElement, sortableHandle } from 'react-sortable-hoc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTrash } from '@fortawesome/pro-solid-svg-icons';
import arrayMove from 'array-move';
import './BlogPostElements.scss';

import { getGMTTime } from '../../Helpers/formatting';
import { isAdmin } from '../../Helpers/user_helpers';

import BlogPostElement from './BlogPostElement';

class BlogPostElements extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    editBlogPostElement: PropTypes.func.isRequired,
    createBlogPostElement: PropTypes.func,
    deleteBlogPostElement: PropTypes.func,
    toggleEditingMode: PropTypes.func,
    isEditing: PropTypes.bool
  };

  state = {
    tempElements: null,
    reorderingMode: false,
    merchant_data: {}
  };

  addElement = type => {
    this.props.createBlogPostElement(this.props.post, type).then(resp => {
      if (this.state.tempElements) {
        this.setState({
          tempElements: [...this.state.tempElements, resp.element]
        });
      }
    });
  };

  deleteElement = element => {
    this.props.deleteBlogPostElement(element).then(resp => {
      if (this.state.tempElements) {
        this.setState({
          tempElements: _.filter(this.state.tempElements, el => el.id !== element.id)
        });
      }
    });
  };

  onSortEnd = async ({ newIndex, oldIndex }) => {
    const { post } = this.props;
    const { isRearranging } = this.state;
    if (isRearranging) return;
    const movingBack = newIndex > oldIndex;
    const elementToUpdate = _.get(post, ['elements', oldIndex]);
    const stampBeforeRank = _.get(post, ['elements', movingBack ? newIndex : newIndex - 1, 'sortOrderRank'], 0);
    const stampAfterRank = _.get(post, ['elements', movingBack ? newIndex + 1 : newIndex, 'sortOrderRank'], getGMTTime());
    const newStampRank = (stampAfterRank + stampBeforeRank) / 2;

    this.setState({
      isRearranging: true,
      tempElements: arrayMove(post.elements, oldIndex, newIndex)
    });
    this.props.editBlogPostElement(elementToUpdate, { sortOrderRank: newStampRank }).then(
      resp => {
        this.setState({ isRearranging: false });
      },
      err => {
        this.setState({ isRearranging: false });
        cogoToast.error('There was an error, please try again.', {
          hideAfter: 2
        });
      }
    );
  };

  render() {
    const { isEditing, post } = this.props;
    const { tempElements, reorderingMode } = this.state;
    const { elements } = post;

    const componentOptions = {
      PARAGRAPH: 'Paragraph',
      HEADER: 'Header',
      HEADER_LARGE: 'Large Header',
      BANNER_IMAGE: 'Banner Image',
      QUOTE_HALF: 'Half Width Quote',
      QUOTE_FULL: 'Full Width Quote',
      PIN_HALF: 'Half Width Pin',
      PIN_FULL: 'Full Width Pin',
      COLLECTION_SHELF: 'Collection Shelf',
      SHOP: 'Shop Preview',
      YOUTUBE: 'Youtube Video',
      INSTAGRAM: 'Instagram Card',
      INSTAGRAM_LARGE: 'Instagram Card Large',
      LINE: 'Line',
      SPACER: 'Spacer',
      SPACER_SMALL: 'Small Spacer',
      DISCLAIMER: 'Disclaimer'
    };

    const componentPanel = (
      <div className={classnames('add-component-container', { active: isEditing })}>
        <div className='add-component-header' onClick={this.props.toggleEditingMode}>
          {isEditing ? 'DONE' : 'EDIT POST'}{' '}
        </div>
        <div
          onClick={() => this.setState({ reorderingMode: !reorderingMode })}
          className={classnames('reorder-elements', {
            reordering: reorderingMode
          })}
        >
          {reorderingMode ? 'DONE REORDERING' : 'REORDER ELEMENTS'}
        </div>
        <div className='add-component-options'>
          {_.map(_.keys(componentOptions), option => (
            <div onClick={() => this.addElement(option)} key={option} className='add-component-option-container'>
              <div className='add-component-option'>{componentOptions[option]}</div>
            </div>
          ))}
        </div>
      </div>
    );

    if (!isEditing || !reorderingMode) {
      return (
        <div className='blog-post-elements-outer-container'>
          {_.map(elements, element => {
            return (
              <BlogPostElement
                key={element.id}
                deleteIcon={
                  !isEditing ? null : (
                    <div className='delete-icn' onClick={() => this.deleteElement(element)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </div>
                  )
                }
                element={element}
                user={this.props.user}
                isEditing={isEditing}
                editBlogPostElement={this.props.editBlogPostElement}
              />
            );
          })}
          {isAdmin(this.props.user) && componentPanel}
        </div>
      );
    }

    const SortableList = SortableContainer(({ items }) => {
      return (
        <div>
          {items.map((element, idx) => (
            <SortableItem axis='xy' key={`element-${element.id}`} index={idx} value={element} />
          ))}
        </div>
      );
    });
    const SortableItem = SortableElement(({ value }) => {
      const element = value;
      const DragHandle = sortableHandle(() => (
        <div className='reorder-icn'>
          <FontAwesomeIcon icon={faBars} />
        </div>
      ));
      return (
        <>
          <BlogPostElement
            dragHandle={<DragHandle />}
            element={element}
            user={this.props.user}
            isEditing={isEditing}
            editBlogPostElement={this.props.editBlogPostElement}
          />
        </>
      );
    });

    return (
      <div className='blog-post-elements-outer-container'>
        <SortableList axis='xy' items={tempElements || elements} onSortEnd={this.onSortEnd} useDragHandle class='abc' helperClass='bcd' />
        {componentPanel}
      </div>
    );
  }
}

export default BlogPostElements;
